import React, { StrictMode } from "react";
import { store, history } from "../../helpers";
import axios from "axios";
import { userActions } from "../../actions";

// const axios = require('axios').default;

export async function customFetch(verb, url, handler, data) {
  const state = store.getState();
  const token = state.authentication.jwt;

  //verify expiry

  const requestOptions = {
    method: verb === "MP-POST" ? "POST" : verb,
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type":
        verb === "MP-POST" ? "multipart/form-data" : "application/json",
    },
  };

  if (verb !== "GET") {
    requestOptions.body = data;
  }

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((responseJson) => {
      return responseJson;
    });
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 403) {
        console.log("response status 403");
        history.push("/login?status=token_expired");
        console.log("pushed history to login");
      } else {
        switch (response.status) {
          case 500: {
            console.log("response status 500");
            break;
          }
          case 401: {
            console.log("response status 401");
            break;
          }
          case 404: {
            console.log("response status 404");
            break;
          }
          default: {
            console.log("response status received: " + response.status);
          }
        }

        const error = (data && data.message) || response.statusText;
        console.log("not ok");
        console.log(error);
        return Promise.reject(error);
      }
    }
    data["newToken"] = response.headers.get("X-Auth-Token");
    return data;
  });
}
